import { render, staticRenderFns } from "./EditProxyDialog.vue?vue&type=template&id=0ba62d56&"
import script from "./EditProxyDialog.vue?vue&type=script&lang=js&"
export * from "./EditProxyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports